import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { I18NService } from './I18NService';

@Directive({
	selector: '[ro-i18n]',
	standalone: false,
})
export class ROI18NDirective implements OnInit {
	@Input('ro-i18n') eight: any;
	@Input() eikey: string;
	private element: any;
	@Input() args: any;
	@Input() count = -1;

	constructor(private elementWrapper: ElementRef) {
		this.element = this.elementWrapper.nativeElement;
	}

	ngOnInit(): void {
		const message: string = I18NService.getMessage(this.eikey, this.args, this.count);
		if (message) {
			this.element.innerHTML = message;
		} else {
			console.warn(`i18n directive key: ${this.eikey}, not found.`);
		}
	}
}
